

import React, { memo } from 'react';
import CommentsContext from '../../../contexts/commentsContext';
import PureCommentsOverlay from '../components/CommentsOverlay';



















function CommentsOverlay(props) {
  return (
    <CommentsContext.Consumer>
      {({
        state: {
          commentModalId,
          isReadOnly,
          closeModalOrigin,
          isInternalMode,
          commentOrigin,
          allowedWriteVisibilityOptions,
          selectedComment
        },
        actions: {
          getUserColor,
          showCommentModal,
          closePopover,
          getOrderedComments,
          updateComment,
          getTotalParentComments,
          setSelectedComment
        } }) => {
        const { selectedClip, filterByClipId, sceneId, shotId } = props;

        const comments = getOrderedComments(
          filterByClipId ?
          selectedClip.clipId :
          void 0,
          sceneId,
          shotId
        );

        const totalParentComments = getTotalParentComments(); // both on-screen and generic comments

        return (
          <PureCommentsOverlay
            {...props}
            getUserColor={getUserColor}
            comments={comments}
            totalParentComments={totalParentComments}
            showCommentModal={showCommentModal}
            commentModalId={commentModalId}
            closePopover={closePopover}
            isReadOnly={isReadOnly}
            selectedClip={selectedClip}
            closeModalOrigin={closeModalOrigin}
            updateComment={updateComment}
            isInternalMode={isInternalMode}
            commentOrigin={commentOrigin}
            allowedWriteVisibilityOptions={allowedWriteVisibilityOptions}
            selectedComment={selectedComment}
            setSelectedComment={setSelectedComment} />);


      }}
    </CommentsContext.Consumer>);

}

export default memo(CommentsOverlay);